export default {
  autocompleteContainer: {
    width: '100%',
  },
};
